module.exports = {
  1: 19169065,
  31: 4777001,
  41: 280843708,
  56: 35875863,
  97: 37477006,
  137: 53161197,
  8453: 10229520,
  17000: 882690,
  42161: 178078567,
  43113: 29752709,
  43114: 41340311,
  59140: 3403822,
  59144: 2075752,
  80001: 45575065,
  84532: 5687996,
  421614: 11915058,
  11155111: 5225447,
  245022926: 308307040,
  245022934: 277792598,
}
